import styled, { css } from 'styled-components';
import { font, themeValue, withSiteTheme } from '../../../../config/css';

const DocumentBrowseCardTitleTheme = {
  default: css`
    display: block;
    transition: color 0.1s linear;

    &.document-browse-card__title {
      .no-image & {
        font-size: ${themeValue('fontSizes', 'xlg')};
        max-height: none;
      }

      .detail-page-aside & {
        font: ${font('md', 'md', 'mwr')};
      }
    }
  `,
  atk: css`
    color: #1f1f1f;
    font: ${font('lg', 'sm', 'mwr')};

    &.document-browse-card__title {
      .no-image & {
        font-size: ${themeValue('fontSizes', 'lg')};
      }
    }

    &:hover {
      color: ${themeValue('colors', 'mint')};
    }

    .carousel & {
      max-height: 6rem;
      overflow: hidden;
    }

    .horizontal & {
      font-family: ${themeValue('fonts', 'mwr')};
      line-height: 1.25;
      font-size: 26px;
    }

    .quick-view-card & {
      font: ${font('lg', 'md', 'pnr')};
    }

    .relateds-shop .related-flat-list & {
      font: ${font('lg', 'sm', 'pnb')};
    }
  `,
};

const DocumentBrowseCardTitle = styled.span.attrs((props) => ({
  className: ['document-browse-card__title', props.visualStyle].join(' '),
}))`
  ${withSiteTheme(DocumentBrowseCardTitleTheme)}
`;

export default DocumentBrowseCardTitle;
